import { createFeatureSelector, createSelector } from '@ngrx/store';
import { loginStoreData } from '../../core/models/Interfaces/login';

export const login = createFeatureSelector<loginStoreData>('login');

export const loginStateData = createSelector(login, (state: any) => state);
